import React from 'react';
import { useDispatch } from 'react-redux';
import { clearOcplcFilters, OcplcKmatLockingQuery, refreshOcplc } from 'actions/ocplcAction';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import UndoIcon from '@mui/icons-material/Undo';
import { iconButtonStyle } from 'pages/DashboardHelpers';
import { LOCAL_STORAGE_KEY, getFromLocalStorage } from 'utils/localStorageUtil';
import { IconButton, Tooltip } from '@mui/material';

export const StartOver = ({ kmatId, ocplcAdmin, userEmail, isEditPage }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleStartOver = async () => {
        const latestRowData = getFromLocalStorage(LOCAL_STORAGE_KEY) || {};
    
        const author = latestRowData.author || userEmail;
        const status = latestRowData.status || '';
        const lastModifiedTime = latestRowData.lastModifiedTS || '';
    
        if (Object.keys(latestRowData).length > 0 && isEditPage) {
            try {
                await dispatch(OcplcKmatLockingQuery(kmatId, ocplcAdmin, author, lastModifiedTime, status, true));
                dispatch(refreshOcplc());
                dispatch(clearOcplcFilters())
                navigate('/ocplc');
            } catch (error) {
                console.error("Error in refreshing OCPLC or locking KMAT", error);
            }
        } else {
            dispatch(refreshOcplc());
            dispatch(clearOcplcFilters())
            navigate('/ocplc');
        }
    };

    return (
        <Tooltip title="Start Over">
            <IconButton
                color="primary"
                sx={{ ...iconButtonStyle }}
                onClick={handleStartOver}
            >
                <UndoIcon />
            </IconButton>
        </Tooltip>
    );
};
